<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Screensaver Add
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          
          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <ValidationProvider 
                            name="File Name" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              File Name
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Slide 1"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.title"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <ValidationProvider 
                            name="Type" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Type
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Image"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="type"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.type = ''; form.content = '';"

                              @change="form.content = ''"
                              
                              v-model="form.type"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <v-menu
                            ref="start"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.start">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Start Date" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Start Date
                                </div>

                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Ex. 2024-03-04"

                                  :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                  clearable
                                  @click:clear="form.start_date = ''; form.end_date = ''; fetch();"

                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.start_date"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              v-model="form.start_date"
                              @input="picker.start = false; form.end_date = ''; fetch();">
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <v-menu
                            ref="end"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.end">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="End Date" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  End Date
                                </div>

                                <v-text-field
                                  readonly
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Ex. 2024-03-05"

                                  :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                  clearable
                                  @click:clear="form.end_date = ''; fetch();"

                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.end_date"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              :min="form.start_date"
                              v-model="form.end_date"
                              @input="picker.end = false; fetch();">
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <ValidationProvider 
                            name="Status" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Status
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Active"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="[
                                {
                                  text: 'Active',
                                  value: true
                                },
                                {
                                  text: 'Not Active',
                                  value: false
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.is_active_bool = ''"
                              
                              v-model="form.is_active_bool"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <div v-if="form.type === 'image'">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Image
                        </div>

                        <folder v-if="form.content === ''"
                          v-model="upload.folder">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="500"
                              height="300"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 10px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.file"
                                v-ripple
                                tile 
                                width="500"
                                height="300">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                :rotate="-90"
                                :size="50"
                                :width="5"
                                :value="onProgress"
                                :color="set_color">
                                {{ onProgress }}
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </folder>

                        <v-card v-if="form.content !== ''"
                          flat
                          width="500"
                          height="300"
                          class="d-flex align-center justify-center"
                          style="border-radius: 10px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            width="500"
                            height="300">
                            <v-img 
                              width="100%"
                              height="100%"
                              alt="tvandroid" 
                              :src="form.content"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.content = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div>

                      <div v-if="form.type === 'video'">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Video
                        </div>

                        <videoupload v-if="form.content === ''"
                          v-model="upload.video">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="500"
                              height="300"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 10px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.file"
                                v-ripple
                                tile 
                                width="500"
                                height="300">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                :rotate="-90"
                                :size="50"
                                :width="5"
                                :value="onProgress"
                                :color="set_color">
                                {{ onProgress }}
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </videoupload>

                        <v-card v-if="!start_video && form.content !== ''"
                          @click="start_video = !start_video"
                          flat
                          width="500"
                          height="300"
                          class="d-flex align-center justify-center"
                          style="border-radius: 10px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-icon
                            size="60"
                            :color="set_color"
                            class="cursor-pointer">
                            mdi-play-circle
                          </v-icon>
                        </v-card>

                        <v-card v-if="start_video && form.content !== ''"
                          flat
                          width="500"
                          height="300"
                          class="d-flex align-center justify-center"
                          style="border-radius: 10px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <video 
                            width="500" 
                            height="300"
                            autoplay
                            controls>
                            <source 
                              :src="form.content"
                              :type="`video/${form.content.split('.').pop()}`">
                          </video>

                          <v-icon 
                            @click="form.content = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div>

                      <div v-if="form.type === 'html'">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          HTML
                        </div>

                        <quill-editor 
                          ref="myTextEditor"
                          :options="{
                            placeholder: 'Ex : Write content in here . . .'
                          }"
                          v-model="form.content">
                        </quill-editor>
                      </div>

                      <div v-if="form.type === 'youtube'">
                        <ValidationProvider 
                          name="Youtube" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>

                            Youtube
                          </div>

                          <v-text-field
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense

                            :color="set_color"
                            placeholder="Ex : https://www.youtube.com/watch?v=HQfF5XRVXjU&feature=youtu.be"
                            :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                            v-model="form.content"
                            :success="valid"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>
                      </div>

                      <div v-if="form.type === 'webview'">
                        <ValidationProvider 
                          name="Webview" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>

                            Webview
                          </div>

                          <v-text-field
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense

                            :color="set_color"
                            placeholder="Ex : https://docs.google.com/presentation/d/e/2PACX-1vSsGu-0c5pcXWnep6jBLsV1M_H2dHTlPt-dmXIAe8rvns699Hj7ARaU97v9o5jTUg/pub?start=true&loop=true&delayms=3000"
                            :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                            v-model="form.content"
                            :success="valid"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>

                        <!-- <iframe v-if="form.content !== '' && form.content !== null"
                          width="800" 
                          height="500" 
                          
                          :src=form.content

                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                          style="border-radius: 10px;">
                        </iframe> -->
                      </div>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        type: [
          {
            text: 'Image',
            value: 'image'
          },
          {
            text: 'Video',
            value: 'video'
          },
          // {
          //   text: 'Html',
          //   value: 'html'
          // },
          // {
          //   text: 'Youtube',
          //   value: 'youtube'
          // },
          // {
          //   text: 'Webview',
          //   value: 'webview'
          // }
        ],

        form: {
          id: '',
          title: '',
          type: '',
          content: '',
          start_date: '',
          end_date: '',
          is_active_bool: true
        },

        start_video: false,

        picker: {
          start: false,
          end: false
        },

        upload: {
          folder: null,
          video: null
        },

        process: {
          form: false,

          file: false
        },
        message: {
          success: '',
          error: ''
        },

        onProgress: null
      }
    },
    components: {
      folder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder_loader.vue'),
      videoupload: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/video_loader.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process
            
            this.onProgress = this.upload.folder.onProgress

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.content = this.upload.folder.file_url
            }
          }
        },
        deep: true
      },

      'upload.video': {
        handler: function () {
          if (this.upload.video) {
            this.process.file = this.upload.video.process

            this.onProgress = this.upload.video.onProgress

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.content = this.upload.video.file_url
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/promo/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.$router.push('/setting/promo')
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>